import React, { FC, Fragment } from 'react';
import { ICourier } from '../../context/couriers';
import CourierListItem from '../CourierListItem';
import useStyles from './styles';

const CourierList: FC<Dictionary<ICourier>> = (couriersById) => {
  const classes = useStyles();
  return (
    <ul className={classes.list}>
      {Object.keys(couriersById).sort((a,b) => couriersById[a]?.firstName?.localeCompare(couriersById[b]?.firstName)).map((id) => (
        <Fragment key={id}>
          {couriersById[id].isGuest &&
          (couriersById[id].orderPool === undefined ||
            couriersById[id].orderPool?.nextOrderReference === null) ? null : (
            
            <CourierListItem {...couriersById[id]} />
          )}
        </Fragment>
      ))}
    </ul>
  );
};

export default CourierList;
